import React from "react";
import { BUSINESS } from "@/lib/constants";
import Seo from "@/components/Seo";
import CtaStrip from "@/components/CtaStrip";

const Section = ({ title, children, testId }) => (
    <section data-testid={testId} className="mt-12">
        <h2 className="font-serif text-2xl sm:text-3xl text-[#1A362B] tracking-tight font-medium">{title}</h2>
        <div className="divider-thin my-5" />
        <div className="space-y-4 text-[#1C1C1C]/80 leading-relaxed">{children}</div>
    </section>
);

export default function TermsPage() {
    return (
        <div data-testid="page-terms" className="pt-20">
            <Seo
                title="Terms & Conditions | Finance Wealth"
                description="Website terms and conditions for financewealth.com.au — Finance Wealth Australia-wide mortgage brokerage."
            />
            <section className="bg-[#F3F1EA]">
                <div className="container-prose py-20 md:py-28">
                    <div className="max-w-3xl">
                        <div className="overline">Legal</div>
                        <h1 className="mt-4 font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02] text-[#1A362B] font-medium">
                            Terms &amp; Conditions.
                        </h1>
                        <div className="divider-thin my-8" />
                        <p className="text-lg text-[#1C1C1C]/75 leading-relaxed font-light">
                            By accessing {BUSINESS.domain} you agree to be bound by these Terms. Please read them carefully.
                        </p>
                    </div>
                </div>
            </section>

            <section className="bg-background">
                <div className="container-prose py-16 max-w-4xl">
                    <Section title="1. About this website" testId="terms-section-1">
                        <p>
                            This website is operated by <strong>{BUSINESS.companyName}</strong> (ABN {BUSINESS.companyAbn})
                            trading as <strong>{BUSINESS.brand}</strong>.
                        </p>
                    </Section>

                    <Section title="2. Information on this website" testId="terms-section-2">
                        <p>
                            Content on this website is provided for general information only and does not constitute
                            personal financial, credit, taxation or legal advice. Interest rates, loan products, fees and
                            calculator outputs are indicative and subject to change without notice.
                        </p>
                        <div className="bg-[#1A362B] text-white p-6 rounded-sm">
                            <p data-testid="terms-disclaimer-statement" className="text-white/90 leading-relaxed italic">
                                Disclaimer: {BUSINESS.disclaimer}
                            </p>
                        </div>
                    </Section>

                    <Section title="3. No warranties" testId="terms-section-3">
                        <p>
                            While we take reasonable care to ensure the accuracy of the information presented, we make no
                            warranty, express or implied, regarding the accuracy, completeness or currency of any
                            information on this website. To the maximum extent permitted by law, {BUSINESS.brand} excludes
                            liability for any loss or damage suffered as a result of relying on information contained on
                            this website.
                        </p>
                    </Section>

                    <Section title="4. Intellectual property" testId="terms-section-4">
                        <p>
                            All trademarks, logos, text, images, layout and other content on this website are owned by or
                            licensed to {BUSINESS.companyName}. You may not reproduce, modify, distribute or commercially
                            exploit any content without our prior written consent.
                        </p>
                    </Section>

                    <Section title="5. Third-party links" testId="terms-section-5">
                        <p>
                            This website may contain links to third-party websites operated by lenders, government bodies
                            and industry partners. We do not endorse or accept responsibility for the content or
                            availability of any third-party sites.
                        </p>
                    </Section>

                    <Section title="6. Privacy" testId="terms-section-6">
                        <p>
                            Personal information collected through this website is handled in accordance with our Credit
                            Guide &amp; Privacy policy. By using this website or submitting a form, you consent to that
                            handling.
                        </p>
                    </Section>

                    <Section title="7. Governing law" testId="terms-section-7">
                        <p>
                            These Terms are governed by the laws of the State of Victoria, Australia. You submit to the
                            non-exclusive jurisdiction of the courts of Victoria.
                        </p>
                    </Section>

                    <Section title="8. Contact" testId="terms-section-8">
                        <p>
                            Questions about these Terms can be sent to <a className="underline hover:text-[#1A362B]" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a> or
                            posted to {BUSINESS.addressLine1}, {BUSINESS.addressLine2}, {BUSINESS.addressLine3}.
                        </p>
                    </Section>

                    <p className="mt-12 text-xs text-[#1C1C1C]/50">
                        These Terms are current as at {new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" })}.
                    </p>
                </div>
            </section>

            <CtaStrip />
        </div>
    );
}
